// Native-shell bootstrap (Capacitor). No-op in the browser so the website is untouched.
import { Capacitor } from "@capacitor/core";

export const isNativeApp = () => Capacitor.isNativePlatform();

export async function initNative() {
  if (!isNativeApp()) return;
  document.documentElement.classList.add("mwq-native", `mwq-native-${Capacitor.getPlatform()}`);
  try {
    const [{ App }, { SplashScreen }, { StatusBar, Style }] = await Promise.all([
      import("@capacitor/app"), import("@capacitor/splash-screen"), import("@capacitor/status-bar"),
    ]);
    // Android hardware back: step through in-app history, leave the app only from the homepage.
    App.addListener("backButton", ({ canGoBack }) => {
      if (window.location.pathname !== "/" && canGoBack) window.history.back();
      else App.exitApp();
    });
    try { await StatusBar.setStyle({ style: Style.Light }); } catch { /* iOS without overlay */ }
    requestAnimationFrame(() => SplashScreen.hide({ fadeOutDuration: 200 }));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn("[native] plugin init skipped", e?.message || e);
  }
}
